import Vue from 'vue';
import './stylesheets/element-ui/_variables.scss';
import App from './App';
import router from './router';
import store from './store';
import init from './common';
import '../src/stylesheets/iconfont/iconfont.js';

Vue.directive('el', {});
import contextMenu from 'vue-context-menu';
contextMenu.props.ctxFocus = {};
// contextMenu.props.align = {}
contextMenu.props.container = {};
contextMenu.methods.setPositionFromEvent = function(e) {
    const { pageX, pageY } = e;
    const top = document.body.clientHeight - pageY;
    this.ctxTop = top < 170 ? pageY - 170 : pageY;
    this.ctxLeft = pageX;
};

Vue.component('context-menu', contextMenu);
import draggable from 'vuedraggable';
Vue.component('draggable', draggable);

Vue.prototype.$ELEMENT = { size: 'mini', zIndex: 3000 };

import Text from 'components/element/Text';
import Image from 'components/element/Image';
import Video from 'components/element/Video';
import Comp from 'components/element/Comp';
import VideoComp from 'components/element/VideoComp';
import Page from 'components/Page';
import VideoPage from 'components/VideoPage';
import ImageButton from 'components/ImageButton';
import UploadAudio from 'components/UploadAudio';

Vue.component('image-button', ImageButton);
Vue.component('upload-audio', UploadAudio);
Vue.component('page', Page);
Vue.component('video-page', VideoPage);
Vue.component('comp', Comp);
Vue.component('video-comp', VideoComp);
Vue.component('comp-text', Text);
Vue.component('comp-image', Image);
Vue.component('comp-video', Video);

import VueWaypoint from 'vue-waypoint';
Vue.use(VueWaypoint);

import MultiSelect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
Vue.component('multi-select', MultiSelect);

init(App, store, router, true);
